import { IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"
import {IEvent} from '../../common/model/Event.model'

export enum IReportMetadataFilter {
  HASH = 'HASH',
  ID = 'ID',
  STATUS = 'STATUS',
  FAMILY = 'FAMILY',
  AREA = 'AREA',
}

export interface IMetadata {
  items: Array<IMetadataSection | IMetadataItem>
  events?: IEvent[]
}

export interface IReportMetadata {
  objectType: string
  createdBy: string
  createdAt: string
  updatedBy: string
  updatedAt: string
  organizationId: string
  id: string
  sequence?: string
  status: string
  family: string
  area: string
  metadata: IMetadata
}

export interface IReportMetadataDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  id: string
  sequence: string
  status: string
  familyCode: string
  family: string
  areaCode: string
  area: string
  metadata: IMetadata
}

export interface IReportMetadataCreateRequestDto {
  createdBy?: string
  createdAt?: string
  organizationId?: string
  status: string
  family: string
  area: string
  metadata: IMetadata
}

export interface IReportMetadataSearchRequestDto {
  organizationId?: string
  pagination?: IPagination
  fields?: TFieldDefinition
  filters?: IFilterDto[]
}

export interface IReportMetadataSearchByAreaRequestDto {
  familyCode: string
  areaCode: string
}

export interface IMetadataItem {
  id?: string //Node ID
  label?: string
  metadataType: IMetadataType
  metricDefault?: string
  metricOptions?: IMetadataItemOption[]
  metricValue?: string
  placeholder?: string //Applies only if "type == INPUT_TEXT"
  required?: boolean //To check if value is provided
  selectOptions?: IMetadataItemOption[] //Applies only if "type == SINGLE_CHOICE | MULTIPLE_CHOICE"
  selectValue?: string //Applies only if "type == SINGLE_CHOICE | MULTIPLE_CHOICE"
  skipEmpty?: boolean //To skip export if value is NOT provided
  title?: string
  type: IMetadataItemType
  typeCheck?: IMetadataTypeCheck //Applies only if "type == INPUT_TEXT"
  value?: any //Applies only if "type == INPUT_TEXT" and "type == TEXTAREA"
  minCheck?: boolean
  minValue?: number
  maxCheck?: boolean
  maxValue?: number
  //Conditional Rendering
  conditionalNote?: string //Note to display in case item is conditional
  conditionalParameter?: string //Parameter to evaluate for conditional rendering
  conditionalParameterValue?: any //Value to compare with parameter for conditional rendering
}

export interface IMetadataItemOption {
  label: string
  value: string
}

export interface IMetadataSection {
  id: string
  items: Array<IMetadataSection | IMetadataItem>
  metadataType: IMetadataType
  sample?: IMetadataSection | IMetadataItem
  sampleMaxSize?: number //Maximum number of times to render the sample
  sampleResizable?: boolean //To specify if section dynamically resizable
  sampleResizableLabel?: string
  sampleSize?: number //Default times to render the sample
  sampleSkippableLabel?: string
  sampleSkippable?: boolean //To specify if section is skipable
  sampleSkipped?: boolean //To skip section if TRUE is provided
  title?: string
}

export enum IMetadataType {
  SECTION = 'SECTION',
  ITEM = 'ITEM',
  ITEM_GROUP = 'ITEM_GROUP',
}

export const ControlTypes = {
  INPUT_TEXT: 'INPUT_TEXT',
  INPUT_NUMBER: 'INPUT_NUMBER',
  TEXTAREA: 'TEXTAREA',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  LABEL: 'LABEL',
}

export type IMetadataItemType =
  | 'DATE'
  | 'DATE_TIME'
  | 'INPUT_TEXT'
  // | 'INPUT_NUMBER'
  // | 'INPUT_EMAIL'
  // | 'INPUT_PHONE_NUMBER'
  // | 'INPUT_LINK'
  // | 'INPUT_DATE'
  // | 'INPUT_TIME'
  | 'TEXTAREA'
  // | 'SINGLE_CHOICE'
  // | 'MULTIPLE_CHOICE'
  // | 'DROPDOWN'
  // | 'LINEAR_SCALE'
  // | 'HIDDEN_FIELDS'
  // | 'CALCULATED_FIELDS'
  // | 'RATING'
  // | 'MATRIX'
  | 'SINGLE_CHOICE'
  | 'MULTIPLE_CHOICE';

export enum IMetadataTypeCheck {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
}